<template>
  <section>
      <multiselect
          v-model="brandVal"
          :options="brandsPromptList"
          :multiple="multiple"
          :close-on-select="!multiple"
          :show-labels="false"
          :clear-on-select="false"
          :searchable="true"
          @close="closeSelect"
          @select="selectAction"
          @input="onChange"
          @search-change="searchChange"
          @open="open"
          size="sm"
      ></multiselect>
    <b-overlay :show="showOverlay > 0" class="overlay" rounded="sm"></b-overlay>
  </section>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
      name: "brandTagSelect",
      props: {
        initBrands: Array,
        tagsChange: Function,
        multiple: Boolean
      },
      components: {
        Multiselect
      },
      data() {
        return {
          brandsPromptList: [],
          brandsList: [],
          sendTimer: null,
          brandSearch: '',
          numberPromptItem: 10,
          isOpen: false,
          showOverlay: 0,
          brandVal: [],
        }
      },
      methods: {
        open: function () {
          this.isOpen = true
        },
        onChange: function () {
          if (!this.isOpen) {
            this.returnValue()
          }
        },
        closeSelect: function () {
          this.isOpen = false
          this.returnValue()
        },
        returnValue: function () {
          this.tagsChange(this.getBrandDataByName(this.brandVal))
        },
        selectAction: function (name) {
          this.brandSearch = name
        },
        searchChange: function (searchQuery) {
          if (searchQuery.length < 2) {
            return
          }
          if (this.sendTimer != null) {
            clearTimeout(this.sendTimer);
          }
          this.sendTimer = setTimeout(() => {this.sendRequest(searchQuery)}, 1000);
        },
        sendRequest: function (searchQuery) {
          this.showOverlay ++
          this.$store.dispatch('SEND_GET', {
            url: '/brand-tag-name?sort=name&sortDir=asc&name='+ searchQuery +'&page=1&pageSize='+
                this.numberPromptItem,
            th: this,
            getSuccessResponse: (data) => {
              this.brandsPromptList = this.getOnlyNames(data.data)
              this.brandsList = data.data
              this.brandsList = this.brandsList.concat(this.initBrands)
            },
            getResponse: () => {
              this.showOverlay --;
            },
            showSuccessMessage: false
          })
        },
        getBrandDataByName: function (name)
        {
          if (Array.isArray(name)) {
            if (name[0] == 'Все' ) {
              return name
            }

            let result = []
            for (let key in this.brandsList) {
              if (name.includes(this.brandsList[key].name) && !result.includes(this.brandsList[key])) {
                let include = false
                for (let key2 in result) {
                  if (result[key2].id == this.brandsList[key].id) {
                    include = true
                  }
                }
                if (!include) {
                  result.push(this.brandsList[key])
                }
              }
            }

            return result
          } else  {
            for (let key in this.brandsList) {
              if (this.brandsList[key].name == name ) {
                return this.brandsList[key]
              }
            }
          }
        }
      },
      computed: {
        getInitData: function () {
          return this.getOnlyNames(this.initBrands)
        }
      },
      mounted() {
      },
      created() {
        this.brandVal = this.getInitData
        this.brandsList = this.initBrands
      },
    }
</script>

<style scoped>
  .overlay {
    z-index: 51;
  }
</style>